export default __webpack_public_path__ + "static/Resolve-Regular-501ad8908d53ae7d50ba85c6b8d6bb6c.woff2";